import { mapAPIAutomatedBreaksSettingsToUI } from '@sdk/automatedBreaks/mappers';
import getScheduledBreaks from '@sdk/automatedBreaks/helpers/getScheduledBreaks';
import { AutomatedBreakPaidCategory } from '@sdk/automatedBreaks/types/AutomatedBreakPaidCategory';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';

import utils from '../utils';
import context from '../context';
import { UNPAID_BREAKS, PAID_BREAKS } from '../constants';

/**
 * shiftDuration can be overriden if we need to accommodate for "partialDuration" an event crosses
 * the defined day split time. If not passed then it defaults to shift.duration
 */
export default function getShiftDurationMinutes(shift, actual, shiftDuration = shift.duration) {
  if (context.orgSettings.automatedBreaksIsEnabled) {
    return getDurationWithAutomatedBreaks(shift, actual, shiftDuration);
  }

  let minutes = actual ? getActualAggregatedDuration(shift) : shiftDuration * 60;
  const breakDuration = actual ? shift.actualBreakDuration : shift.breakDuration;

  if (breakDuration && context.laborCostSettings) {
    if (context.laborCostSettings.shiftBreakType === UNPAID_BREAKS) {
      minutes -= breakDuration;
    } else if (
      context.laborCostSettings.shiftBreakType === PAID_BREAKS &&
      actual &&
      shift.actualBreakDuration > shift.breakDuration
    ) {
      minutes -= shift.actualBreakDuration - shift.breakDuration;
    }
  }

  return Math.round(Math.max(minutes, 0));
}

function getActualAggregatedDuration(shift) {
  if (!shift.timesheets || !shift.timesheets.length) {
    return 0;
  }

  const timesheetGroups = utils.breakDownTimesheetsToGroups(shift.timesheets);

  return timesheetGroups.reduce(
    (acc, group) =>
      acc +
      ((group[group.length - 1].clockOut || utils.getNowDate()) - group[0].clockIn) / 1000 / 60,
    0
  );
}

function getDurationWithAutomatedBreaks(shift, actual, shiftDuration) {
  if (actual) {
    const breaksSummary = getBreaksSummary(shift.timesheetEntries, shift.dtstart, shift.dtend);
    let paidDurationMinutes = getActualAggregatedDuration(shift);

    breaksSummary.breakRecords.forEach((breakRecord) => {
      if (
        breakRecord.settings.isPaid &&
        breakRecord.breakDurationInMinutes > breakRecord.settings.duration
      ) {
        paidDurationMinutes -= breakRecord.breakDurationInMinutes - breakRecord.settings.duration;
      } else if (!breakRecord.settings.isPaid) {
        paidDurationMinutes -= breakRecord.breakDurationInMinutes;
      }
    });

    return Math.round(Math.max(paidDurationMinutes, 0));
  }

  const automatedBreaksSettings = mapAPIAutomatedBreaksSettingsToUI(context.orgSettings);
  const scheduledAutomatedBreaks = getScheduledBreaks({ shift, automatedBreaksSettings });

  let paidDurationMinutes = shiftDuration * 60;
  if (automatedBreaksSettings.meal.isPaid === AutomatedBreakPaidCategory.unpaid) {
    paidDurationMinutes -= scheduledAutomatedBreaks.mealTotalDuration;
  }

  if (automatedBreaksSettings.rest.isPaid === AutomatedBreakPaidCategory.unpaid) {
    paidDurationMinutes -= scheduledAutomatedBreaks.restTotalDuration;
  }

  return Math.round(Math.max(paidDurationMinutes, 0));
}
